module.exports = __webpack_public_path__ + "static/media/YANG MING.1d7aa3f3.svg";